function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ProductDisc");

var SvgProductDisc = function SvgProductDisc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 163.336 110",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8.142,
    cy: 10.401,
    r: 3.742,
    transform: "translate(-2.164 2.139) rotate(-13.226)",
    style: {
      fill: "#7a66a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.918,
    cy: 81.99,
    r: 3.742,
    transform: "translate(-17.939 9.249) rotate(-13.226)",
    style: {
      fill: "#7a66a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.257,
    cy: 73.022,
    r: 3.742,
    transform: "translate(-12.615 37.23) rotate(-13.226)",
    style: {
      fill: "#7a66a3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.142,
    y1: 10.401,
    x2: 77.721,
    y2: 5.763,
    style: {
      fill: "#7a66a3",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.076,
    y1: 11.658,
    x2: 153.452,
    y2: 74.859,
    style: {
      fill: "none",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.721,
    y1: 6.633,
    x2: 30.918,
    y2: 81.99,
    style: {
      fill: "none",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.142,
    y1: 10.401,
    x2: 127.554,
    y2: 103.657,
    style: {
      fill: "none",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.918,
    y1: 81.99,
    x2: 127.554,
    y2: 103.657,
    style: {
      fill: "none",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.257,
    y1: 73.022,
    x2: 77.721,
    y2: 6.633,
    style: {
      fill: "none",
      stroke: "#7a66a3",
      strokeMiterlimit: 10,
      strokeWidth: "0.869734096946928px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.776,
    cy: 103.483,
    r: 2.851,
    style: {
      fill: "#7a66a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.896,
    cy: 6.35,
    r: 2.851,
    transform: "translate(21.187 60.13) rotate(-48.142)",
    style: {
      fill: "#7a66a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.721,115.548l-15.514-1.034-.689-8.274-3.447,7.24L37.9,111.411c.345-13.1,5.861-25.856,6.205-27.58s1.169-8.846,1.169-8.846c1.507-3.2,9.4-3.5,15.589-3.206,2.565.117,4.84.338,6.243.5.927.1,1.476.179,1.476.179a21.605,21.605,0,0,1,5.044,9.9C77.157,96.325,72.721,115.548,72.721,115.548Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.483,
    cy: 26.948,
    r: 8.619,
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.623,29.016S47.209,39.7,43.417,42.806s14.824,0,14.824,0-4.137-6.895-1.034-10S49.623,29.016,49.623,29.016Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,73.144l-5.719.634-16,1.779s-.076-.2-.21-.572C44.114,71.817,38.518,56.4,37.9,51.77c-.689-5.171,6.55-11.377,6.55-11.377a84.733,84.733,0,0,1,8.963-1.379c2.068,0,10.342,3.1,10.342,3.1l3.085,27.756.265,2.4Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.627,82.352,62.033,75.557s-.2-.662-.548-1.779c-.172-.558-.383-1.234-.621-2-1.338-4.3-3.582-11.384-5.381-16.562C52.725,47.288,66.17,69.352,66.17,69.352l.672.521.265,2.4c.927.1,1.476.179,1.476.179A21.605,21.605,0,0,1,73.627,82.352Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.241,42.806s-3.447,4.482-.689,12.411,6.55,20.34,6.55,20.34l20,11.721,2.758-3.447L68.239,69.352s-.689-26.2-4.137-27.235A7.064,7.064,0,0,0,58.241,42.806Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.176,72.971s4.826,10,6.895,8.963S42.9,70.558,42.9,70.558Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.659,45.564,22.388,60.733s-6.895,4.826,5.861,8.274,13.79,5.516,13.79,5.516,1.379-4.482,3.1-3.792l-14.824-7.24,12.066-7.24Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.316,34.022a48.672,48.672,0,0,0,4.88-2.588c-.126-3.757.336-7.167,1.69-8.974a19.853,19.853,0,0,1,3.606-4.814c3.07-3.341,9.858-5.207,11.062-3.537,9.106.18,10.065,7.318,10.065,7.318-.047,2.986-3.15,3.08-5.868,2.971.243,2.038-.405,4.156-2.284,5.1-3.592,1.8-4.67,4.131-2.874,5.747s5.029,5.927.718,7-4.849,3.233-3.592,4.131-2.874-1.616-2.874-1.616-.718,4.31-4.49,3.233a2.269,2.269,0,0,1-1.008-.714c-1.019,1.119-1.927,1.781-2.612,1.785-3.923.021-3.452-4.324-3.452-4.324s-4.656,1.308-3.2.782,1.515-2.746-2.345-4.946S31.15,35.094,33.316,34.022Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#724279",
      strokeMiterlimit: 10,
      strokeWidth: "1.5052902293679051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.225,38.148a23.179,23.179,0,0,1-3.067,11.973,23.925,23.925,0,0,1-2.18,3.131C136.825,62,123.526,66.789,111.507,74.546c-35.479,22.894-39.322-13.791-37.719-36.4A40.335,40.335,0,0,1,83.63,14.274a37.464,37.464,0,0,1,3.831-3.766A36.693,36.693,0,0,1,111.507,1.75a37.716,37.716,0,0,1,35.219,23.341,35.259,35.259,0,0,1,2.5,13.057Z",
    style: {
      fill: "#fb9ca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.543,9.953,83.63,14.274a37.464,37.464,0,0,1,3.831-3.766Z",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.158,50.122a23.925,23.925,0,0,1-2.18,3.131l-30.763-3.7Z",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.981,28.845,95.844,22.083l50.882,3.008A35.069,35.069,0,0,1,147.981,28.845Z",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.966,83.816s8.274.345,8.274,2.413-9.308,0-9.308,0Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.555,115.532,57.041,114.5l-.689-8.274-3.447,7.24L37.735,111.4c.345-13.1,5.861-25.856,6.205-27.58s1.169-8.846,1.169-8.846c1.507-3.2,9.4-3.5,15.589-3.206,2.565.117,4.84.338,6.243.5.927.1,1.476.179,1.476.179a21.605,21.605,0,0,1,5.044,9.9C76.992,96.309,72.555,115.532,72.555,115.532Z",
    style: {
      fill: "#b3a8ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.317,
    cy: 26.932,
    r: 8.619,
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.457,29s-2.413,10.687-6.205,13.79,14.824,0,14.824,0-4.137-6.895-1.034-10S49.457,29,49.457,29Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.039,73.128l-5.719.634-16,1.779s-.076-.2-.21-.572c-1.162-3.168-6.757-18.585-7.374-23.215-.689-5.171,6.55-11.377,6.55-11.377A84.733,84.733,0,0,1,53.249,39c2.068,0,10.342,3.1,10.342,3.1l3.085,27.756.265,2.4Z",
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.461,82.337,61.868,75.542s-.2-.662-.548-1.779c-.172-.558-.383-1.234-.621-2-1.338-4.3-3.582-11.384-5.381-16.562C52.559,47.272,66,69.336,66,69.336l.672.521.265,2.4c.927.1,1.476.179,1.476.179A21.605,21.605,0,0,1,73.461,82.337Z",
    style: {
      fill: "#b1a0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.075,42.791s-3.447,4.482-.689,12.411,6.55,20.34,6.55,20.34l20,11.721,2.758-3.447L68.073,69.336s-.689-26.2-4.137-27.235A7.064,7.064,0,0,0,58.075,42.791Z",
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.01,72.956s4.826,10,6.895,8.963-5.171-11.377-5.171-11.377Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.493,45.549,22.222,60.718s-6.895,4.826,5.861,8.274,13.79,5.516,13.79,5.516,1.379-4.482,3.1-3.792l-14.824-7.24,12.066-7.24Z",
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.15,34.006a48.672,48.672,0,0,0,4.88-2.588c-.126-3.757.336-7.167,1.69-8.974a19.853,19.853,0,0,1,3.606-4.814c3.07-3.341,9.858-5.207,11.062-3.537,9.106.18,10.065,7.318,10.065,7.318-.047,2.986-3.15,3.08-5.868,2.971.243,2.038-.405,4.156-2.284,5.1-3.592,1.8-4.67,4.131-2.874,5.747s5.029,5.927.718,7-4.849,3.233-3.592,4.131-2.874-1.616-2.874-1.616-.718,4.31-4.49,3.233a2.269,2.269,0,0,1-1.008-.714c-1.019,1.119-1.927,1.781-2.612,1.785-3.923.021-3.452-4.324-3.452-4.324s-4.656,1.308-3.2.782,1.515-2.746-2.345-4.946S30.984,35.079,33.15,34.006Z",
    style: {
      fill: "#e57373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.276,45.268l-.063-.008.153.58a15.239,15.239,0,0,0,.626,2.38l4.474,17.008a2.883,2.883,0,0,0,2.347,2.115l9.124,1.412a2.883,2.883,0,0,0,2.982-1.488l8.671-16.2a15.217,15.217,0,0,0,.742-1.385l.294-.55-.046-.006a15.33,15.33,0,1,0-29.3-3.862Z",
    style: {
      fill: "#633a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,69.866a3.138,3.138,0,0,1-.48-.037l-9.537-1.476a3.147,3.147,0,0,1-2.563-2.31L81.241,48.265a16.031,16.031,0,0,1-.657-2.5l-.118-.778a16.162,16.162,0,0,1,18.5-18.025l-.041.266a15.9,15.9,0,0,0-18.169,17.9l.091.582a15.926,15.926,0,0,0,.651,2.478l4.68,17.788a2.878,2.878,0,0,0,2.344,2.112l9.537,1.476a2.883,2.883,0,0,0,2.978-1.486l.237.127A3.154,3.154,0,0,1,98.5,69.866Z",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.742,
    y: 56.942,
    width: 16.874,
    height: 0.348,
    transform: "translate(10.783 129.664) rotate(-69.885)",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.464,
    y: 47.667,
    width: 0.348,
    height: 16.874,
    transform: "translate(-2.374 4.077) rotate(-2.516)",
    style: {
      fill: "#d3ecee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.692,77.925,85.471,76.035a.348.348,0,0,1,.107-.689L97.8,77.237a.348.348,0,0,1-.1.689Z",
    style: {
      fill: "#633a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.005,75.33,85.784,73.44a.348.348,0,0,1,.1-.689h0l12.221,1.891a.348.348,0,0,1-.1.689Z",
    style: {
      fill: "#633a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.318,72.735,86.1,70.844a.348.348,0,0,1,.107-.689l12.221,1.891a.348.348,0,0,1-.107.689Z",
    style: {
      fill: "#633a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,79.436c2.424.375,4.6-.672,4.856-2.339l-8.778-1.358C87.021,77.406,88.777,79.061,91.2,79.436Z",
    style: {
      fill: "#633a69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.594,45.8a2.146,2.146,0,0,1-1.189-.769c-.078-.091-.153-.185-.229-.279a2.72,2.72,0,0,0-.9-.835c-.8-.373-1.741.148-2.557.707l-.2-.287c.9-.615,1.942-1.183,2.9-.735a3.019,3.019,0,0,1,1.022.933c.073.091.147.182.222.27.246.287.736.753,1.262.645a1.7,1.7,0,0,0,.605-.32,3.242,3.242,0,0,1,.428-.27,1.706,1.706,0,0,1,1.873.265,3.37,3.37,0,0,1,.254.269.867.867,0,0,0,1.4.165,1.8,1.8,0,0,1,1.054-.316l.038.005c.686.106,1,.865,1.181,1.431l-.332.1c-.243-.77-.539-1.153-.928-1.2a1.531,1.531,0,0,0-.848.276,1.189,1.189,0,0,1-1.829-.242,3.069,3.069,0,0,0-.227-.241,1.369,1.369,0,0,0-1.483-.21,2.94,2.94,0,0,0-.382.243,1.979,1.979,0,0,1-.737.377A1.145,1.145,0,0,1,95.594,45.8Z",
    style: {
      fill: "#d3ecee"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductDisc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProductDisc.6138b406.svg";
export { ForwardRef as ReactComponent };